export default {
  // pc
  NavigationBar() {
    return import('@/components/portal/NavigationBar')
  },
  NavigationBarConfig() {
    return import('../components/config/NavigationBarConfig')
  },
  NewsOne() {
    return import('@/components/portal/NewsOne')
  },
  NewsTwo() {
    return import('@/components/portal/NewsTwo')
  },
  NewsThree() {
    return import('@/components/portal/NewsThree')
  },
  NewsFour() {
    return import('@/components/portal/NewsFour')
  },
  NewsConfig() {
    return import('../components/config/NewsConfig')
  },
  BayWindow() {
    return import('@/components/portal/BayWindow')
  },
  BayWindowConfig() {
    return import('../components/config/BayWindowConfig')
  },
  URLHref() {
    return import('@/components/portal/URLHref')
  },
  URLIframe() {
    return import('@/components/portal/URLIframe')
  },
  HyperLinksConfig() {
    return import('../components/config/HyperLinksConfig')
  },
  HorizontalImageWall() {
    return import('@/components/portal/HorizontalImageWall')
  },
  VerticalImageWall() {
    return import('@/components/portal/VerticalImageWall')
  },
  TopicConfig() {
    return import('../components/config/TopicConfig')
  },
  Carousel() {
    return import('@/components/portal/Carousel')
  },
  CarouselConfig() {
    return import('../components/config/CarouselConfig')
  },
  ImageNews() {
    return import('@/components/portal/ImageNews')
  },
  ImageNewsTwo() {
    return import('@/components/portal/ImageNewsTwo')
  },
  ImageNewsConfig() {
    return import('../components/config/ImageNewsConfig')
  },
  NewsVideo() {
    return import('@/components/portal/NewsVideo')
  },
  NewsVideoTwo() {
    return import('@/components/portal/NewsVideoTwo')
  },
  NewsVideoConfig() {
    return import('../components/config/NewsVideoConfig')
  },
  NewsImageConfig() {
    return import('../components/config/NewsImageConfig')
  },
  BannerLong() {
    return import('@/components/portal/BannerLong')
  },
  BannerConfig() {
    return import('../components/config/BannerConfig')
  },
  NewsHtml() {
    return import('@/components/portal/NewsHtml')
  },
  NewsHtmlConfig() {
    return import('../components/config/NewsHtmlConfig')
  },
  GlobalConfig() {
    return import('../components/config/GlobalConfig')
  },
  Breadcrumb() {
    return import('@/components/portal/Breadcrumb')
  },
  // app
  AppNavigationBarConfig() {
    return import('../components/appConfig/AppNavigationBarConfig')
  },
  AppNewsConfig() {
    return import('../components/appConfig/NewsConfig')
  },
  AppCarouselConfig() {
    return import('../components/appConfig/AppCarouselConfig')
  },
  H5BannerConfig() {
    return import('../components/appConfig/H5BannerConfig')
  },
  H5NewsImageConfig() {
    return import('../components/appConfig/H5NewsImageConfig')
  },
  H5NewsVideoConfig() {
    return import('../components/appConfig/H5NewsVideoConfig')
  },
  H5TopicConfig() {
    return import('../components/appConfig/H5TopicConfig')
  },
  H5HorizontalImageWall() {
    return import('@/components/appPortal/H5HorizontalImageWall')
  },
  H5VerticalImageWall() {
    return import('@/components/appPortal/H5VerticalImageWall')
  },
  H5BannerLong() {
    return import('@/components/appPortal/H5BannerLong')
  },
  H5HorizontalNewsVideoList() {
    return import('@/components/appPortal/H5HorizontalNewsVideoList')
  },
  H5VerticalNewsVideoList() {
    return import('@/components/appPortal/H5VerticalNewsVideoList')
  },
  H5HorizontalNewsImageList() {
    return import('@/components/appPortal/H5HorizontalNewsImageList')
  },
  H5VerticalNewsImageList() {
    return import('@/components/appPortal/H5VerticalNewsImageList')
  },
  AppCarousel() {
    return import('@/components/appPortal/AppCarousel')
  },
  AppList() {
    return import('@/components/appPortal/AppList')
  },
  AppListConfig() {
    return import('../components/appConfig/AppListConfig')
  },
  AppNavigation() {
    return import('@/components/appPortal/AppNavigation')
  },
  AppLoadMoreConfig() {
    return import('../components/appConfig/AppLoadMoreConfig')
  },
  AppLoadMore() {
    return import('@/components/appPortal/AppLoadMore')
  },
}
